import * as React from "react";
const SvgBruise = (props) => /* @__PURE__ */ React.createElement("svg", { contentScriptType: "text/ecmascript", xmlnsXlink: "http://www.w3.org/1999/xlink", zoomAndPan: "magnify", contentStyleType: "text/css", viewBox: "0 0 128 128", preserveAspectRatio: "xMidYMid meet", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("defs", null), /* @__PURE__ */ React.createElement("text", { x: 85, y: 77, style: {
  fontSize: "12pt",
  stroke: "none",
  fill: "#ff0033",
  fontFamily: "'Arial',sans-serif"
}, transform: "matrix( 0, 3.6666666128417904, -3.1828103894197004, 0, 291.84985184443076, -260.184056253357)" }, "\n    X\n  "));
export default SvgBruise;
